@let data = review();

<div class="review-sticky">
<div
  class="review-summary"
  role="group"
  aria-label="Resumo da aprovação">
  <div class="review-stat">
    <span class="review-stat-label">Itens a aprovar</span>
    <strong class="review-stat-value">{{ itemsLabel() }}</strong>
  </div>
  <div class="review-stat">
    <span class="review-stat-label">Fornecedores</span>
    <strong class="review-stat-value">{{ data.suppliers.length }}</strong>
  </div>
  <div class="review-stat">
    <span class="review-stat-label">Total</span>
    <strong class="review-stat-value">{{ data.totalValue | currency: 'BRL' : 'symbol' : '1.2-2' }}</strong>
  </div>
  <div class="review-stat review-stat--success">
    <span class="review-stat-label">Economia obtida</span>
    <strong class="review-stat-value">{{ data.totalSaving | currency: 'BRL' : 'symbol' : '1.2-2' }}</strong>
  </div>
</div>

@if (data.selectedItemsCount > 0) {
  <!-- Critério da escolha em uma linha: o porquê que o aprovador não vê no mapa. -->
  <p class="review-criteria">
    <mat-icon aria-hidden="true">insights</mat-icon>
    <span>
      <strong>{{ data.bestPriceCount }} de {{ data.selectedItemsCount }}</strong>
      {{ data.selectedItemsCount === 1 ? 'item' : 'itens' }} no menor preço cotado
    </span>
    <span
      class="review-criteria-sep"
      aria-hidden="true"
      >·</span
    >
    <span>
      média de <strong>{{ data.averageQuotes | number: '1.1-1' }}</strong>
      {{ data.averageQuotes === 1 ? 'cotação' : 'cotações' }} por item
    </span>
    @if (data.singleQuoteCount > 0) {
      <span
        class="review-criteria-sep"
        aria-hidden="true"
        >·</span
      >
      <span class="review-criteria-warn">
        {{ data.singleQuoteCount === 1 ? '1 item teve' : data.singleQuoteCount + ' itens tiveram' }} uma cotação só
      </span>
    }
  </p>
}

@if (data.hasExpired) {
  <div
    class="review-alert review-alert--error"
    role="alert">
    <mat-icon aria-hidden="true">event_busy</mat-icon>
    <span>Há fornecedor com cotação vencida entre os selecionados. Confirme os preços antes de aprovar.</span>
  </div>
}
@if (data.negotiatedNotAppliedCount > 0) {
  <div
    class="review-alert review-alert--warning"
    role="alert">
    <mat-icon aria-hidden="true">price_change</mat-icon>
    <span>
      {{
        data.negotiatedNotAppliedCount === 1
          ? '1 valor negociado não está valendo'
          : data.negotiatedNotAppliedCount + ' valores negociados não estão valendo'
      }}: a seleção ficou no preço cotado. Para aplicar, volte ao mapa e marque o negociado.
    </span>
  </div>
}
@if (data.aboveQuotedCount > 0) {
  <div
    class="review-alert review-alert--warning"
    role="alert">
    <mat-icon aria-hidden="true">warning</mat-icon>
    <span>
      {{ data.aboveQuotedCount === 1 ? '1 item tem' : data.aboveQuotedCount + ' itens têm' }} valor negociado acima do
      cotado. Confira antes de continuar.
    </span>
  </div>
}
</div>

@for (supplier of data.suppliers; track supplier.id) {
  <details
    class="review-supplier"
    [style.--review-accent]="supplier.accentColor"
    [open]="data.suppliers.length <= 3">
    <summary class="review-supplier-header">
      <mat-icon
        class="review-supplier-chevron"
        aria-hidden="true"
        >expand_more</mat-icon
      >
      <div class="review-supplier-identity">
        <strong class="review-supplier-name">{{ supplier.name }}</strong>
        <span class="review-supplier-meta">
          @if (supplier.email) {
            <span>{{ supplier.email }}</span>
          }
          @if (supplier.respondedAt) {
            <span>· Respondido em {{ supplier.respondedAt | date: 'dd/MM/yyyy' }}</span>
          }
          @for (condicao of supplier.payment ?? []; track condicao) {
            <span>· {{ condicao }}</span>
          }
          @if (supplier.validityLabel) {
            <span
              class="review-validity"
              [class.review-validity--expired]="supplier.validityStatus === 'expired'"
              [class.review-validity--expiring]="supplier.validityStatus === 'expiring'"
              >{{ supplier.validityLabel }}</span
            >
          }
        </span>
      </div>
      <div class="review-supplier-subtotal">
        <span class="review-stat-label">{{ supplier.items.length }} {{ supplier.items.length === 1 ? 'item' : 'itens' }} · Subtotal</span>
        <strong>{{ supplier.subtotal | currency: 'BRL' : 'symbol' : '1.2-2' }}</strong>
      </div>
    </summary>

    <table class="review-table">
      <thead>
        <tr>
          <th scope="col">Código</th>
          <th scope="col">Produto</th>
          <th
            scope="col"
            class="num">
            Qtd
          </th>
          <th
            scope="col"
            class="num">
            Cotado
          </th>
          <th
            scope="col"
            class="num">
            Negociado
          </th>
          <th scope="col">Concorrência</th>
          <th
            scope="col"
            class="num">
            Total
          </th>
        </tr>
      </thead>
      <tbody>
        @for (item of supplier.items; track item.code) {
          <tr [class.review-row--above]="item.aboveQuoted">
            <td class="code">{{ item.code }}</td>
            <td
              class="product"
              [title]="item.product">
              {{ item.product }}
              @if (item.branch) {
                <span class="review-branch">{{ item.branch }}</span>
              }
            </td>
            <td class="num">{{ item.quantity }} {{ item.unit }}</td>
            <td
              class="num"
              [class.muted]="item.useNegotiated">
              {{ item.price | currency: 'BRL' : 'symbol' : '1.2-2' }}
            </td>
            <td
              class="num"
              [class.applied]="item.useNegotiated"
              [class.not-applied]="item.negotiatedNotApplied">
              @if (item.negotiatedPrice != null) {
                {{ item.negotiatedPrice | currency: 'BRL' : 'symbol' : '1.2-2' }}
                @if (item.negotiatedNotApplied) {
                  <span class="review-not-applied">não aplicado</span>
                }
                @if (item.aboveQuoted) {
                  <mat-icon
                    class="review-above-icon"
                    aria-label="Acima do cotado"
                    >warning</mat-icon
                  >
                }
              } @else {
                <span class="muted">—</span>
              }
            </td>
            <td class="competition">
              @let c = item.competition;
              @if (c.quotes === 0) {
                <span class="muted">—</span>
              } @else {
                @if (c.quotes === 1) {
                  <span
                    class="review-badge review-badge--warning"
                    aionzTooltip="Só este fornecedor mandou preço para o item: não houve concorrência."
                    mode="message"
                    >Cotação única</span
                  >
                } @else if (c.isBest) {
                  <span class="review-badge review-badge--success">Menor preço</span>
                } @else {
                  <span
                    class="review-badge review-badge--neutral"
                    [aionzTooltip]="
                      'Menor preço: ' + (c.bestPrice | currency: 'BRL' : 'symbol' : '1.2-2') + ' · ' + c.bestSupplierName
                    "
                    mode="message"
                    [attr.aria-label]="
                      (c.aboveBest ?? 0 | percent: '1.0-0') +
                      ' acima do menor preço, de ' +
                      (c.bestPrice | currency: 'BRL' : 'symbol' : '1.2-2') +
                      ', cotado por ' +
                      c.bestSupplierName
                    "
                    >+{{ c.aboveBest ?? 0 | percent: '1.0-0' }} do menor</span
                  >
                }
                <span class="review-quotes">
                  {{ c.quotes }} {{ c.quotes === 1 ? 'cotação' : 'cotações' }}
                </span>
              }
            </td>
            <td class="num total">
              {{ item.lineTotal | currency: 'BRL' : 'symbol' : '1.2-2' }}
              @if (item.saving > 0) {
                <span class="review-line-saving">
                  Economia de {{ item.saving | currency: 'BRL' : 'symbol' : '1.2-2' }}
                </span>
              }
            </td>
          </tr>
        }
        <!-- Frete como mais uma linha da lista (não é resumo): nome na coluna Produto. -->
        <tr class="review-freight">
          <td class="code"></td>
          <td class="product">Frete</td>
          <td class="num"></td>
          @if (supplier.freight; as freight) {
            <td
              class="num"
              [class.muted]="freight.useNegotiated">
              {{ freight.quoted | currency: 'BRL' : 'symbol' : '1.2-2' }}
            </td>
            <td
              class="num"
              [class.applied]="freight.useNegotiated"
              [class.not-applied]="freight.negotiatedNotApplied">
              @if (freight.negotiated != null) {
                {{ freight.negotiated | currency: 'BRL' : 'symbol' : '1.2-2' }}
                @if (freight.negotiatedNotApplied) {
                  <span class="review-not-applied">não aplicado</span>
                }
              } @else {
                <span class="muted">—</span>
              }
            </td>
            <td></td>
            <td class="num total">
              {{ freight.applied | currency: 'BRL' : 'symbol' : '1.2-2' }}
              @if (freight.saving > 0) {
                <span class="review-line-saving">
                  Economia de {{ freight.saving | currency: 'BRL' : 'symbol' : '1.2-2' }}
                </span>
              }
            </td>
          } @else {
            <td
              colspan="4"
              class="num muted">
              Não incluído
            </td>
          }
        </tr>
      </tbody>
    </table>
  </details>
}

@if (data.unselectedItems.length > 0) {
  <details class="review-unselected">
    <summary>
      {{ data.unselectedItems.length }}
      {{ unselectedLabel() }}
    </summary>
    <ul>
      @for (item of data.unselectedItems; track item.code) {
        <li>
          <span class="code">#{{ item.code }}</span>
          <span
            class="product"
            [title]="item.product"
            >{{ item.product }}</span
          >
          <span class="muted">{{ item.quantity }} {{ item.unit }}</span>
        </li>
      }
    </ul>
  </details>
}
